import {
	a as e,
	c as t,
	f as n,
	i as r,
	n as i,
	o as a,
	p as o,
	s,
	t as c,
	u as l,
} from "./cart-surface-operations-DDPgeARZ.js";
import "./country-selector-gnpshGLt.js";
(function () {
	let e = document.createElement(`link`).relList;
	if (e && e.supports && e.supports(`modulepreload`)) return;
	for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) n(e);
	new MutationObserver((e) => {
		for (let t of e)
			if (t.type === `childList`)
				for (let e of t.addedNodes)
					e.tagName === `LINK` && e.rel === `modulepreload` && n(e);
	}).observe(document, { childList: !0, subtree: !0 });
	function t(e) {
		let t = {};
		return (
			e.integrity && (t.integrity = e.integrity),
			e.referrerPolicy && (t.referrerPolicy = e.referrerPolicy),
			e.crossOrigin === `use-credentials`
				? (t.credentials = `include`)
				: e.crossOrigin === `anonymous`
					? (t.credentials = `omit`)
					: (t.credentials = `same-origin`),
			t
		);
	}
	function n(e) {
		if (e.ep) return;
		e.ep = !0;
		let n = t(e);
		fetch(e.href, n);
	}
})();
var u = `[data-main-cart]`,
	d = `input[data-cart-line]`,
	f = `[data-cart-quantity-change]`,
	p = `[data-main-cart-remove]`,
	m = `[data-main-cart-remove-notice]`,
	h = `[data-main-cart-remove-status]`,
	g = `[data-main-cart-undo]`,
	_ = `[data-main-cart-live-region]`,
	v = `[data-cart-coupon]`,
	y = `[data-cart-coupon-form]`,
	b = `[data-cart-coupon-input]`,
	x = `[data-cart-coupon-reveal]`,
	S = `[data-cart-coupon-remove]`,
	C = `[data-cart-pending-checkout-code-remove]`,
	w = `[data-cart-pending-checkout-code]`,
	T = `[data-cart-pending-checkout-code-value]`,
	E = `[data-cart-coupon-status]`,
	D = `[data-cart-checkout-form]`,
	O = `[data-cart-checkout-code]`,
	k = `[data-main-cart-primary-checkout]`,
	A = `[data-main-cart-sticky-checkout]`,
	j = `[data-main-cart-sticky-checkout-action]`,
	M = null,
	N = class N {
		abortController;
		cart;
		couponForm;
		couponInput;
		couponRemove;
		couponReveal;
		couponStatus;
		checkoutCodeInput;
		checkoutForm;
		checkoutVisibilityObserver;
		form;
		pendingCheckoutCodeRemove;
		pendingCheckoutCode;
		pendingCheckoutCodeValue;
		primaryCheckout;
		stickyCheckout;
		stickyCheckoutAction;
		removeNotice;
		removeStatus;
		undoAction;
		liveRegion;
		removedLine;
		removeStatusTimer;
		timers;
		constructor(e) {
			M?.cart !== e && M?.destroy(),
				(this.cart = e),
				(this.form = e.querySelector(`.main-cart__form`)),
				(this.couponForm = e.querySelector(y)),
				(this.couponInput = e.querySelector(b)),
				(this.couponReveal = e.querySelector(x)),
				(this.couponRemove = e.querySelector(S)),
				(this.couponStatus = e.querySelector(E)),
				(this.pendingCheckoutCodeRemove = e.querySelector(C)),
				(this.pendingCheckoutCode = e.querySelector(w)),
				(this.pendingCheckoutCodeValue = e.querySelector(T)),
				(this.checkoutForm = e.querySelector(D)),
				(this.checkoutCodeInput = e.querySelector(O)),
				(this.primaryCheckout = e.querySelector(k)),
				(this.stickyCheckout = e.querySelector(A)),
				(this.stickyCheckoutAction = e.querySelector(j)),
				(this.removeNotice = e.querySelector(m)),
				(this.removeStatus = e.querySelector(h)),
				(this.undoAction = e.querySelector(g)),
				(this.liveRegion = e.querySelector(_)),
				(this.removedLine = null),
				(this.removeStatusTimer = void 0),
				(this.checkoutVisibilityObserver = null),
				(this.timers = new WeakMap()),
				(this.abortController = null),
				(this.handleInput = this.handleInput.bind(this)),
				(this.handleChange = this.handleChange.bind(this)),
				(this.handleClick = this.handleClick.bind(this)),
				(this.restoreRemovedLine = this.restoreRemovedLine.bind(this)),
				(this.handleCouponReveal = this.handleCouponReveal.bind(this)),
				(this.handleCouponSubmit = this.handleCouponSubmit.bind(this)),
				(this.handleCouponRemove = this.handleCouponRemove.bind(this)),
				(this.handlePendingCheckoutCodeRemove =
					this.handlePendingCheckoutCodeRemove.bind(this)),
				(this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this)),
				(this.handleStickyCheckout = this.handleStickyCheckout.bind(this)),
				this.form?.addEventListener(`input`, this.handleInput),
				this.form?.addEventListener(`change`, this.handleChange),
				this.form?.addEventListener(`click`, this.handleClick),
				this.undoAction?.addEventListener(`click`, this.restoreRemovedLine),
				this.couponReveal?.addEventListener(`click`, this.handleCouponReveal),
				this.couponForm?.addEventListener(`submit`, this.handleCouponSubmit),
				this.couponRemove?.addEventListener(`click`, this.handleCouponRemove),
				this.pendingCheckoutCodeRemove?.addEventListener(
					`click`,
					this.handlePendingCheckoutCodeRemove,
				),
				this.checkoutForm?.addEventListener(
					`submit`,
					this.handleCheckoutSubmit,
				),
				this.stickyCheckoutAction?.addEventListener(
					`click`,
					this.handleStickyCheckout,
				),
				this.restorePendingCheckoutCode(),
				this.initStickyCheckout(),
				(M = this);
		}
		initStickyCheckout() {
			!this.primaryCheckout ||
				!this.stickyCheckout ||
				((this.checkoutVisibilityObserver = new IntersectionObserver(([e]) => {
					let t =
						this.primaryCheckout.getBoundingClientRect().top >=
						window.innerHeight;
					this.setStickyCheckoutVisible(!e.isIntersecting && t);
				})),
				this.checkoutVisibilityObserver.observe(this.primaryCheckout));
		}
		setStickyCheckoutVisible(e) {
			(this.stickyCheckout.hidden = !e),
				this.primaryCheckout.toggleAttribute(`aria-hidden`, e),
				e
					? this.primaryCheckout.setAttribute(`tabindex`, `-1`)
					: this.primaryCheckout.removeAttribute(`tabindex`);
		}
		handleStickyCheckout() {
			this.primaryCheckout?.click();
		}
		destroy() {
			this.checkoutVisibilityObserver?.disconnect(),
				window.clearTimeout(this.removeStatusTimer);
		}
		handleInput(e) {
			let t = e.target.closest(d);
			t &&
				(clearTimeout(this.timers.get(t)),
				this.timers.set(
					t,
					window.setTimeout(() => this.updateLine(t), 450),
				));
		}
		handleChange(e) {
			let t = e.target.closest(d);
			t && (clearTimeout(this.timers.get(t)), this.updateLine(t));
		}
		handleClick(e) {
			if (!(e.target instanceof Element)) return;
			let t = e.target.closest(p);
			if (t) {
				let n = Number.parseInt(t.dataset.cartLine ?? ``, 10),
					r = this.readRemovedLine(t);
				if (!Number.isFinite(n) || !r) return;
				e.preventDefault(), this.removeLine(n, r);
				return;
			}
			let n = e.target.closest(f);
			if (!n) return;
			let r = n.closest(`[data-cart-quantity-control]`)?.querySelector(d),
				i = Number.parseInt(n.dataset.cartQuantity ?? ``, 10),
				a = Number.parseInt(n.dataset.cartQuantityChange ?? ``, 10);
			!r ||
				!Number.isFinite(i) ||
				!Number.isFinite(a) ||
				((r.value = `${Math.max(1, i + a)}`), this.updateLine(r));
		}
		readRemovedLine(e) {
			let t = Number.parseInt(e.dataset.cartQuantity ?? ``, 10),
				n = String(e.dataset.cartVariantId || ``).trim();
			if (!n || !Number.isFinite(t) || t < 1) return null;
			let r = {};
			try {
				let t = JSON.parse(e.dataset.cartProperties || `{}`);
				t && typeof t == `object` && !Array.isArray(t) && (r = t);
			} catch {
				r = {};
			}
			let i = String(e.dataset.cartSellingPlanId || ``).trim();
			return {
				properties: r,
				quantity: t,
				...(i ? { sellingPlanId: i } : {}),
				variantId: n,
			};
		}
		async removeLine(e, t) {
			this.abortController?.abort();
			let n = new AbortController();
			(this.abortController = n), this.setPending(!0);
			try {
				let r = await c({
					currentRoot: this.cart,
					rootSelector: u,
					sectionId: this.cart.dataset.sectionId,
					eventSource: `main-cart`,
					line: e,
					quantity: 0,
					signal: n.signal,
				});
				if (!r.ok) throw Error(r.message);
				new N(r.root).showRemovedLineMessage(t);
			} catch (e) {
				e.name !== `AbortError` &&
					console.warn(`Unable to remove cart line`, e);
			} finally {
				n.signal.aborted || this.setPending(!1);
			}
		}
		showRemovedLineMessage(e) {
			!this.removeNotice ||
				!this.removeStatus ||
				(window.clearTimeout(this.removeStatusTimer),
				(this.removedLine = e),
				(this.removeStatus.textContent =
					this.cart.dataset.cartLineRemovedMessage || ``),
				this.undoAction?.removeAttribute(`hidden`),
				(this.removeNotice.hidden = !1),
				this.undoAction?.focus(),
				(this.removeStatusTimer = window.setTimeout(() => {
					this.removeNotice?.contains(document.activeElement) &&
						this.cart.querySelector(`.main-cart__heading`)?.focus(),
						this.removeNotice && (this.removeNotice.hidden = !0),
						(this.removedLine = null),
						(this.removeStatusTimer = void 0);
				}, 3e3)));
		}
		async restoreRemovedLine() {
			if (!this.removedLine) return;
			let e = this.removedLine;
			window.clearTimeout(this.removeStatusTimer),
				(this.removeStatusTimer = void 0),
				this.setPending(!0);
			try {
				let n = await t({
					currentRoot: this.cart,
					rootSelector: u,
					sectionId: this.cart.dataset.sectionId,
					eventSource: `main-cart`,
					...e,
				});
				if (!n.ok) throw Error(n.message);
				let r = new N(n.root);
				r.liveRegion &&
					(r.liveRegion.textContent =
						r.cart.dataset.cartLineRestoredMessage || ``),
					(
						[...r.cart.querySelectorAll(`[data-cart-line-key]`)]
							.find(
								(e) =>
									e.getAttribute(`data-cart-line-key`) === n.restoredLineKey,
							)
							?.querySelector(`.main-cart__item-title a`) ||
						r.cart.querySelector(`.main-cart__heading`)
					)?.focus();
			} catch (e) {
				(this.removedLine = null),
					this.removeStatus &&
						((this.removeStatus.textContent =
							this.cart.dataset.cartLineRestoreErrorMessage || ``),
						this.removeStatus.setAttribute(`tabindex`, `-1`),
						this.removeStatus.focus()),
					this.undoAction && (this.undoAction.hidden = !0),
					(this.removeStatusTimer = window.setTimeout(() => {
						this.removeNotice?.contains(document.activeElement) &&
							this.cart.querySelector(`.main-cart__heading`)?.focus(),
							this.removeNotice && (this.removeNotice.hidden = !0),
							(this.removeStatusTimer = void 0);
					}, 3e3)),
					console.warn(`Unable to restore cart line`, e);
			} finally {
				this.setPending(!1);
			}
		}
		handleCouponReveal() {
			this.revealCouponForm();
		}
		revealCouponForm({ focus: e = !0 } = {}) {
			this.couponForm &&
				((this.couponForm.hidden = !1),
				this.couponReveal?.setAttribute(`aria-expanded`, `true`),
				this.couponReveal?.setAttribute(`hidden`, ``),
				e && this.couponInput?.focus());
		}
		handleCouponSubmit(e) {
			e.preventDefault();
			let t = this.couponInput?.value.trim() || ``;
			if (!t) {
				this.showCouponMessage(r(this.cart), !0);
				return;
			}
			this.updateCoupon(t);
		}
		handleCouponRemove() {
			this.updateCoupon(``);
		}
		handlePendingCheckoutCodeRemove() {
			if (!e()) {
				this.updateCoupon(``);
				return;
			}
			i(),
				this.syncCheckoutCodeInput(``),
				this.cart
					.querySelector(v)
					?.classList.remove(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = ``),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !0),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !0),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = ``),
				this.showCouponMessage(``, !1),
				this.cart.querySelector(`[data-cart-coupon-applied]`) ||
					this.revealCouponForm();
		}
		handleCheckoutSubmit(t) {
			let n = a();
			if (!n) {
				this.syncCheckoutCodeInput(e());
				return;
			}
			t.preventDefault(), this.goToCheckoutUrl(n);
		}
		async updateLine(e) {
			let t = Number.parseInt(e.dataset.cartLine, 10),
				n = Number.parseInt(e.dataset.cartQuantity, 10),
				r = Number.parseInt(e.value, 10);
			if (!Number.isFinite(t) || !Number.isFinite(n)) return;
			if (!Number.isFinite(r)) {
				e.value = `${n}`;
				return;
			}
			let i = Math.max(1, r);
			if (((e.value = `${i}`), i === n)) return;
			this.abortController?.abort();
			let a = new AbortController();
			(this.abortController = a), this.setPending(!0);
			try {
				let e = await c({
					currentRoot: this.cart,
					rootSelector: u,
					sectionId: this.cart.dataset.sectionId,
					eventSource: `main-cart`,
					line: t,
					quantity: i,
					signal: a.signal,
				});
				if (!e.ok) throw Error(e.message);
				new N(e.root);
			} catch (e) {
				if (e.name === `AbortError`) return;
				console.warn(`Unable to update cart`, e);
			} finally {
				a.signal.aborted || this.setPending(!1);
			}
		}
		async updateCoupon(t) {
			this.setPending(!0);
			try {
				let a = await n({
						currentRoot: this.cart,
						rootSelector: u,
						couponSelector: v,
						sectionId: this.cart.dataset.sectionId,
						eventSource: `main-cart`,
						code: t,
					}),
					s =
						(a.root || this.cart) === this.cart
							? this
							: new N(a.root || this.cart);
				if (!a.ok) {
					if (a.reason === `invalid_coupon` && t) {
						s.setPending(!0);
						let e = await o(t, r(s.cart));
						s.setPending(!1),
							e.ok
								? s.showPendingCheckoutCode(t, e.checkoutUrl)
								: (i(), s.showCouponMessage(e.message, !0));
						return;
					}
					s.showCouponMessage(a.message, !0);
					return;
				}
				if (a.removed && e()) s.restorePendingCheckoutCode();
				else {
					!a.removed &&
						!s.couponRemove &&
						a.appliedCode &&
						s.showAppliedCouponCode(a.appliedCode, a.discountValue);
					let e = a.removed
						? ``
						: s.cart.dataset.couponSuccessMessage || `Coupon code toegepast.`;
					s.showCouponMessage(e, !1), a.removed && s.revealCouponForm();
				}
			} catch (e) {
				this.showCouponMessage(e.message, !0),
					console.warn(`Unable to update coupon code`, e);
			} finally {
				this.setPending(!1);
			}
		}
		async refresh() {
			let e = await s({
				currentRoot: this.cart,
				rootSelector: u,
				sectionId: this.cart.dataset.sectionId,
			});
			if (!e.ok) throw Error(e.message);
			new N(e.root);
		}
		setPending(e) {
			this.cart.querySelectorAll(`button, input`).forEach((t) => {
				t.toggleAttribute(`aria-busy`, e), (t.disabled = e);
			});
		}
		showCouponMessage(e, t = !1) {
			this.couponStatus &&
				((this.couponStatus.textContent = e || ``),
				this.couponStatus.classList.toggle(`is-error`, !!t));
		}
		showPendingCheckoutCode(e, t = ``) {
			let n = l(e, t);
			if (!n) return;
			this.syncCheckoutCodeInput(n),
				this.cart.querySelector(v)?.classList.add(`is-pending-checkout-code`);
			let r = this.cart.querySelector(`[data-cart-coupon-label]`);
			r && (r.hidden = !0),
				this.couponInput && (this.couponInput.value = n),
				this.couponForm && (this.couponForm.hidden = !0),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponReveal?.setAttribute(`aria-expanded`, `false`),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !1),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = n),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !1),
				this.showCouponMessage(
					this.cart.dataset.checkoutCodePendingMessage ||
						`Code toegevoegd. Deze wordt toegepast bij het afrekenen.`,
					!1,
				);
		}
		showAppliedCouponCode(e, t = ``) {
			let n = String(e || ``).trim();
			if (!n) return;
			i(), this.syncCheckoutCodeInput(``);
			let r = this.cart.querySelector(`[data-cart-coupon-label]`),
				a = r?.textContent?.trim() || ``;
			r && (r.hidden = !0),
				this.couponForm && (this.couponForm.hidden = !0),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponReveal?.setAttribute(`aria-expanded`, `false`),
				this.pendingCheckoutCodeValue &&
					(this.pendingCheckoutCodeValue.textContent = [
						a,
						n,
						String(t || ``).trim(),
					]
						.filter(Boolean)
						.join(` · `)),
				this.pendingCheckoutCode && (this.pendingCheckoutCode.hidden = !1);
		}
		restorePendingCheckoutCode() {
			let t = e(),
				n = a();
			t && n && this.showPendingCheckoutCode(t, n);
		}
		syncCheckoutCodeInput(e) {
			if (!this.checkoutCodeInput) return;
			let t = String(e || ``).trim();
			(this.checkoutCodeInput.value = t),
				t
					? (this.checkoutCodeInput.name = `checkout[reduction_code]`)
					: this.checkoutCodeInput.removeAttribute(`name`);
		}
		goToCheckoutUrl(e) {
			let t = new URL(String(e || ``), window.location.href);
			[`http:`, `https:`].includes(t.protocol) &&
				(window.location.href = t.toString());
		}
	};
document.querySelectorAll(u).forEach((e) => {
	new N(e);
}),
	document.addEventListener(`cart:updated`, (e) => {
		e.detail?.source !== `main-cart` &&
			M?.refresh().catch((e) => {
				console.warn(`Unable to refresh cart page`, e);
			});
	});
